import React, {useState, useEffect} from 'react'
import { Roles } from "../core-components/utility-components/UserUtils";
import * as S from "../../styles/ezev-td-styles/LandingPage-styles";

function CondensedGroupDownloadPdf(props){
   const [disabledButton, setDisabledButton] = useState(true)
  
    useEffect(() => {
       if(props.dataLoading || !props.energyGraphData) {
        setDisabledButton(true);
      } else {
        setDisabledButton(false);
      }
    },[props.energyGraphData, props.dataLoading])
  
  function handleButtonClick() {
    props.openModal()
  }

  return(
    // Button is only for email reports and super admins and needs to be hidden in UI
    <S.PdfDownloadContainer style={{display: props.user.role >= Roles.SuperAdmin ? 'initial' : 'none'}}>
      <S.TableDownloadLink
        onClick={handleButtonClick}
        href={props.link}
        disabled={disabledButton}
        data-testid="condensedPdfDownload-testid"
        id='condensedPdfDownloadBtn'
      >
    Condensed PDF
      </S.TableDownloadLink>
    </S.PdfDownloadContainer>
  );
}

export default CondensedGroupDownloadPdf;